<div class="event-details mt-4 mt-md-0">
  <app-event-edit
    [isSimpleMode]="true"
    [isCreating]="isCreating"
    [id]="id"
  ></app-event-edit>
</div>
